import { render, staticRenderFns } from "./myStrategy.vue?vue&type=template&id=1a3bcaf6&scoped=true&"
import script from "./myStrategy.vue?vue&type=script&lang=js&"
export * from "./myStrategy.vue?vue&type=script&lang=js&"
import style0 from "./myStrategy.vue?vue&type=style&index=0&id=1a3bcaf6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a3bcaf6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a3bcaf6')) {
      api.createRecord('1a3bcaf6', component.options)
    } else {
      api.reload('1a3bcaf6', component.options)
    }
    module.hot.accept("./myStrategy.vue?vue&type=template&id=1a3bcaf6&scoped=true&", function () {
      api.rerender('1a3bcaf6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/personalCenter/myStrategy.vue"
export default component.exports